import type { ExtractParams } from './extract-params';
import type { TestIds } from './test-ids';

export const getTestId = <T extends TestIds>(
  testId: T,
  ...restParams: ExtractParams<T> extends undefined ? [] : [ExtractParams<T>]
) => {
  const [params] = restParams;
  if (!params) {
    return testId;
  }
  return Object.entries(params).reduce((result: string, [key, value]) => {
    return value ? result.replace(`[${key}]`, value.toString()) : result;
  }, testId);
};
